<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <div class="container py-5">
          <div class="row d-flex justify-content-center">
            <div class="col-md-12">
              <div class="card chat-window" id="chat1" style="border-radius: 15px;">
                <div
                    class="card-header d-flex justify-content-between align-items-center p-3 bg-primary text-white border-bottom-0"
                    style="border-top-left-radius: 15px; border-top-right-radius: 15px;">
                  <p class="mb-0 fw-bold">Chat History {{uid === 'Others' ? '(Others)' :''}}</p>
                </div>
                <div class="card-body chat-window">
                  <section v-for="(chat, index) of chatHistory" :key="index">
                    <div v-if="!chat.isAdmin" class="d-flex flex-row justify-content-start">
                      <div class="d-flex flex-row justify-content-start mb-4">
                        <img :src="`https://www.gravatar.com/avatar/${emailHash}?s=100`"
                             alt="avatar 1" style="width: 40px; height: 44px; border-radius: 50%; margin-right: 5px">
                        <div class="px-3 pt-2 ms-3" style="min-width:300px; border-radius: 15px; background-color: rgba(57, 192, 237,.2);">
                          <small class="text-primary mb-2"><b class="mr-2">{{chat.sender}}</b></small>
                          <p class="small mb-0">{{ chat.message }}</p>
                          <div class="text-right pb-2">
                            <small style="color: #5e5e5e">{{ getTime(chat.time) }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="d-flex flex-row justify-content-end mb-4 align-items-center">
                      <small v-if="chat.failed" class="mr-2"><span class="text-danger cursor-pointer ml-2" >Failed</span></small>
                      <div class="d-flex flex-row justify-content-end ">
                        <div class="px-3 pt-2 me-3 border" style="min-width:300px; border-radius: 15px; background-color: #fbfbfb;">
                          <small class="text-primary mb-2"><b class="mr-2">{{uid === 'Others' ? ` ${chat.to}` : chat.sender}}</b></small>
                          <p class="small mb-0">{{ chat.message }}</p>
                          <div class="text-right pb-2">
                            <small style="color: #5e5e5e">{{ getTime(chat.time) }}</small>
                          </div>
                        </div>
                        <img src="/logo.jpg"
                             alt="avatar 1" style="width: 40px; height: 44px; border-radius: 50%;margin-left: 5px">
                      </div>
                    </div>


                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {db} from "@/firebase/init";
import md5 from 'crypto-js/md5'
import moment from 'moment'

export default {
  name: "chatHistory",
  props: {
    uid: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      loading: false,
      chatHistory: [],
      listener: null
    }
  },
  watch: {
    uid: {
      immediate: true,
      handler () {
        this.getUserChat()
      }
    }
  },
  computed: {
    emailHash () {
      return this.email ?  md5(this.email.trim().toLowerCase()).toString() : ''
    }
  },
  methods: {
    getTime(time){
      return moment(time).format('MMM Do, YYYY hh:mm A')
    },
    async getUserChat () {
      this.loading = true;
      try {
        console.log(this.uid)
        this.chatHistory=[]
        if (this.listener) {
          this.listener()
        }
        this.listener = await db.collection('conversations').doc(this.uid).onSnapshot(change => {
          if (change.exists) {
            const data = change.data();
            this.chatHistory= data.chats.reverse()
          } else {
            this.chatHistory = []
          }
        });
        // if (chatRef.exists) {
        //   this.chatHistory = chatRef.data().chats.reverse()
        // } else {
        //   this.chatHistory = []
        // }
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    }
  },
  destroyed() {
    if (this.listener) {
      this.listener()
    }
  }
}
</script>

<style scoped>

#chat1 .form-outline .form-control~.form-notch div {
  pointer-events: none;
  border: 1px solid;
  border-color: #eee;
  box-sizing: border-box;
  background: transparent;
}

#chat1 .form-outline .form-control~.form-notch .form-notch-leading {
  left: 0;
  top: 0;
  height: 100%;
  border-right: none;
  border-radius: .65rem 0 0 .65rem;
}

#chat1 .form-outline .form-control~.form-notch .form-notch-middle {
  flex: 0 0 auto;
  max-width: calc(100% - 1rem);
  height: 100%;
  border-right: none;
  border-left: none;
}

#chat1 .form-outline .form-control~.form-notch .form-notch-trailing {
  flex-grow: 1;
  height: 100%;
  border-left: none;
  border-radius: 0 .65rem .65rem 0;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-leading {
  border-top: 0.125rem solid #39c0ed;
  border-bottom: 0.125rem solid #39c0ed;
  border-left: 0.125rem solid #39c0ed;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-leading,
#chat1 .form-outline .form-control.active~.form-notch .form-notch-leading {
  border-right: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-middle {
  border-bottom: 0.125rem solid;
  border-color: #39c0ed;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-middle,
#chat1 .form-outline .form-control.active~.form-notch .form-notch-middle {
  border-top: none;
  border-right: none;
  border-left: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-trailing {
  border-top: 0.125rem solid #39c0ed;
  border-bottom: 0.125rem solid #39c0ed;
  border-right: 0.125rem solid #39c0ed;
}

#chat1 .form-outline .form-control:focus~.form-notch .form-notch-trailing,
#chat1 .form-outline .form-control.active~.form-notch .form-notch-trailing {
  border-left: none;
  transition: all 0.2s linear;
}

#chat1 .form-outline .form-control:focus~.form-label {
  color: #39c0ed;
}

#chat1 .form-outline .form-control~.form-label {
  color: #bfbfbf;
}
.chat-window {
  height: 500px;
  overflow-y: scroll;
}
</style>